<mat-table [dataSource]="service.conversations">
	<ng-container matColumnDef="checkbox">
		<mat-header-cell *matHeaderCellDef>
			<mat-checkbox
				(change)="$event ? toggleAll() : null"
				[checked]="selection.hasValue() && isAllSelected()"
				[indeterminate]="selection.hasValue() && !isAllSelected()"
				[color]="checkboxColor"
				class="toggle-all-checkbox"
			>
			</mat-checkbox>
		</mat-header-cell>
		<mat-cell *matCellDef="let element">
			<mat-checkbox
				(click)="$event.stopPropagation()"
				(change)="$event ? toggleCheckbox(element) : null"
				[checked]="selection.isSelected(element)"
				[color]="checkboxColor"
				class="single-checkbox"
			>
			</mat-checkbox>
		</mat-cell>
	</ng-container>

	<ng-container matColumnDef="watch">
		<mat-header-cell *matHeaderCellDef></mat-header-cell>
		<mat-cell *matCellDef="let element">
			<button
				class="d-flex justify-content-center align-items-center"
				(click)="changeWatchingState(element)"
				mat-icon-button
			>
				<ng-container *ngIf="!loadingStates.get(element.id + '_watch'); else spinner">
					<i *ngIf="element.watching; else notWatching" style="color: #df0000" class="fas fa-heart"></i>
					<ng-template #notWatching>
						<i class="far fa-heart"></i>
					</ng-template>
				</ng-container>
				<ng-template #spinner>
					<mat-spinner diameter="20"> </mat-spinner>
				</ng-template>
			</button>
		</mat-cell>
	</ng-container>

	<ng-container matColumnDef="subject">
		<mat-header-cell *matHeaderCellDef> Temat </mat-header-cell>
		<mat-cell
			[ngClass]="{
				'fw-bold': element.unread > 0,
			}"
			routerLink="/thread/{{ element.id }}/"
			(click)="service.clearCache()"
			*matCellDef="let element"
		>
			{{ element.subject }}
		</mat-cell>
	</ng-container>

	<ng-container matColumnDef="date">
		<mat-header-cell *matHeaderCellDef class="justify-content-end"> Data utworzenia </mat-header-cell>
		<mat-cell *matCellDef="let element" class="justify-content-end">
			{{ element.date | date: 'dd.MM.YYYY | HH:mm' }}
		</mat-cell>
	</ng-container>

	<ng-container matColumnDef="archive">
		<mat-header-cell *matHeaderCellDef></mat-header-cell>
		<mat-cell *matCellDef="let element" class="justify-content-center">
			<ng-container *ngIf="!loadingStates.get(element.id + '_archived'); else spinner">
				<button mat-icon-button [matMenuTriggerFor]="menu" class="emailMenu">
					<i class="fas fa-ellipsis-v"></i>
				</button>
				<mat-menu #menu="matMenu">
					<button (click)="openTaskDialog(element.subject)" mat-menu-item class="text-center task-button">
						Utwórz zadanie <i class="fas fa-tasks"></i>
					</button>

					<button
						mat-menu-item
						class="archive-single-button text-center"
						(click)="changeArchivedAndSetFilers(element)"
					>
						{{ isArchived(element) ? 'Przywróć' : 'Archiwizuj' }}
						<i [ngClass]="isArchived(element) ? 'fa-undo-alt' : 'fa-archive'" class="fas"></i>
					</button>
					<button
						mat-menu-item
						class="assign-me-button text-center"
						(click)="openAssignMessageDialog([element], DialogType.USER)"
					>
						Przypisz użytkownika <i class="fas fa-user"></i>
					</button>
					<button
						mat-menu-item
						class="assign-reservation-button text-center"
						(click)="openAssignMessageDialog([element], DialogType.RESERVATION)"
					>
						Przypisz rezerwację
						<i class="fas fa-suitcase-rolling"></i>
					</button>
					<!--					<button-->
					<!--						(click)="changeReadState(element)"-->
					<!--						mat-menu-item-->
					<!--						class="text-center read-button"-->
					<!--					>-->
					<!--						<ng-container *ngIf="isUnRead(element); else isRead">-->
					<!--							Oznacz jako przeczytane-->
					<!--							<i class="fas fa-envelope-open"></i-->
					<!--						></ng-container>-->
					<!--						<ng-template #isRead>-->
					<!--							Oznacz jako nieprzeczytane-->
					<!--							<i class="fas fa-envelope"></i-->
					<!--						></ng-template>-->
					<!--					</button>-->
				</mat-menu>
			</ng-container>
			<ng-template #spinner>
				<mat-spinner diameter="20"> </mat-spinner>
			</ng-template>
		</mat-cell>
	</ng-container>

	<mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
	<mat-row
		*matRowDef="let row; columns: displayedColumns"
		[style.background-color]="row.replied ? '' : '#3f51b545'"
	></mat-row>
</mat-table>
<div *ngIf="service.isLoadingResults" class="spinner-container">
	<mat-progress-spinner color="primary" mode="indeterminate"> </mat-progress-spinner>
</div>
